
import {examineList,GoodpregnancyList,TimeLimitList} from './js/gift';
import {urlConfig} from '@/api/urlConfig';
import {fetch,promptMessage} from '@/api/dataHandling';
import XHeader from 'vux/src/components/x-header/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

export default {
data(){
return{
Examineimg:'',
contentClass:'',
employ:'',

}
},
directives: {
TransferDom
},
components: {
Confirm,XHeader
},
methods:{
getInventoryData(id){
this.$store.commit('updateLoadingStatus',{isLoading:true});
fetch('get',urlConfig.jifenInventory + '?goodsId=' + id).then(response => {
console.log(response.goodsNum)
if(response.goodsNum != 0){   //有库存
fetch('post',urlConfig.jifengetTel+'?personInfoId='+this.$route.query.personInfoId).then(response => {  //获取电话号码
this.tel = response;
let goodPoints = 0;
let title = this.$route.query.title;
let list = [];
if(title =='好孕礼包'){
list = GoodpregnancyList;
}else if(title == '限时礼包'){
list = TimeLimitList;
}
for(let i =0;i<list.length;i++){
if(list[i].goodid == this.$route.query.goodid){
goodPoints = list[i].points;
this.title = list[i].txt;
}
}
this.exchangeParma = new URLSearchParams();
this.exchangeParma.append('personInfoId',this.$route.query.personInfoId);
this.exchangeParma.append('orderMoney',goodPoints);
this.exchangeParma.append('mobile',this.tel);
this.exchangeParma.append('goodsInfos',this.$route.query.goodid + ":1");
this.exchangeParma.append('gzhArea',this.paramsData.hosCode);
fetch('post',urlConfig.jifenPayIntegral,this.exchangeParma).then(response => {

this.$router.push({ path: 'integralMallOrder', query: {bigtitle:'好孕礼包',mobile:this.tel,orderId: response.orderId,personInfoId:this.$route.query.personInfoId,title:this.title,num:1,total:goodPoints,integra:this.$route.query.Mypoints,xm:this.xm,sfzh:this.sfzh,openid:this.$route.query.openid,sign:this.$route.query.sign,hosCode:this.paramsData.hosCode}})

}).catch(error => {
})
}).catch(error => {
});
}else{
promptMessage('提示','没有库存了，请联系客服028-65003333！')
}

}).catch(error => {

})
},//获取库存信息
submit(){

if(this.$route.query.Mypoints >= this.changePoint){
this.getInventoryData(this.$route.query.goodid);
}else{
promptMessage('提示','积分不足，无法兑换该礼包，兑换礼包需花费'+this.changePoint+'积分')
}
}
},
mounted(){
this.sfzh = this.$route.query.sfzh;
this.xm = this.$route.query.xm;
if(window.localStorage.getItem('card')){
this.employ = window.localStorage.getItem('card');
}
console.log(this.employ,'员工身份')
let title = this.$route.query.title;
if(title =='好孕礼包'){  // 好孕礼包
let goodid = this.$route.query.goodid;
for(let i = 0;i<GoodpregnancyList.length;i++){
if(goodid == GoodpregnancyList[i].goodid){
this.Examineimg = GoodpregnancyList[i].imgdetail;
this.changePoint = GoodpregnancyList[i].points;
}
}
}else if(title == '诊疗服务'){    //诊疗服务
for(let i = 0;i<examineList.length;i++){
if(this.$route.query.urlimg == examineList[i].txt){
this.Examineimg = examineList[i].detail;
}
}
}else if(title == '限时礼包'){
let goodid = this.$route.query.goodid;
for(let i = 0;i<TimeLimitList.length;i++){
if(goodid == TimeLimitList[i].goodid){
this.Examineimg = TimeLimitList[i].imgdetail;
this.changePoint = TimeLimitList[i].points;
if(TimeLimitList[i].txt =='简约OL通勤'){
this.contentClass ='ol';
}else if(TimeLimitList[i].txt =='端午节气'){
this.contentClass ='dw';
}else if(TimeLimitList[i].txt =='缤纷盛夏'){
this.contentClass ='sx';
}else if(TimeLimitList[i].txt =='助力JCI'){
this.contentClass ='jci';
}else if(TimeLimitList[i].txt =='健康宝贝驱蚊礼包' || TimeLimitList[i].txt =='品质生活礼包'){
this.contentClass ='jk';
}
}
}
console.log(this.Examineimg)
}

}
}



// WEBPACK FOOTER //
// ./src/project/integralMallProject/integralMallExamine.vue